import { render, staticRenderFns } from "./PrincipalRevenueFormDialog.vue?vue&type=template&id=c1b4b6f8&scoped=true"
import script from "./PrincipalRevenueFormDialog.vue?vue&type=script&lang=js"
export * from "./PrincipalRevenueFormDialog.vue?vue&type=script&lang=js"
import style0 from "./PrincipalRevenueFormDialog.vue?vue&type=style&index=0&id=c1b4b6f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b4b6f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1b4b6f8')) {
      api.createRecord('c1b4b6f8', component.options)
    } else {
      api.reload('c1b4b6f8', component.options)
    }
    module.hot.accept("./PrincipalRevenueFormDialog.vue?vue&type=template&id=c1b4b6f8&scoped=true", function () {
      api.rerender('c1b4b6f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/PrincipalRevenueFormDialog.vue"
export default component.exports